import React from "react"
import MainPage from "./layout/MainPage"


function App() {
  return <MainPage />
}

export default App;
